import React from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./utils/secure-route/AuthContext";
import RouteManager from "./utils/secure-route/routeManager/RouteManager";
import { ConfigProvider } from './context/ConfigContext';
import "./assets/css/fonts.css";
import "./assets/css/App.css";
import "./assets/css/style.css";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./components/common/Footer";
import { ToastHandlerProvider } from "./components/common/ToastHandler";
import { StoreProvider } from './context/StoreContext';


const App = () => {
  return (

      <ToastHandlerProvider>
        <div className="">
          <BrowserRouter>
            <div className="app-shell">
              <AuthProvider>
                <StoreProvider>
                  <ConfigProvider>
                    <div className="app-shell-main">
                      <RouteManager />
                    </div>
                    <Footer />
                  </ConfigProvider>
                </StoreProvider>
              </AuthProvider>
            </div>
          </BrowserRouter>
        </div>
      </ToastHandlerProvider>

  );
}

export default App;
